var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSummariesMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.03,15.84c-.11,0-.22-.02-.32-.05-1.62-.55-2.71-2.08-2.71-3.79V4C0,1.79,1.79,0,4,0h12c2.21,0,4,1.79,4,4v8c0,1.67-1.06,3.18-2.63,3.76-.52.19-1.09-.08-1.28-.6-.19-.52.08-1.09.6-1.28.79-.29,1.31-1.04,1.31-1.88V4c0-1.1-.9-2-2-2H4c-1.1,0-2,.9-2,2v8c0,.86.54,1.62,1.35,1.89.52.18.8.75.62,1.27-.14.42-.53.68-.95.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,14c-1.65,0-3-1.35-3-3s1.35-3,3-3,3,1.35,3,3-1.35,3-3,3ZM10,10c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1-.45-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,19c-.55,0-1-.45-1-1s-.45-1-1-1h-4c-.55,0-1,.45-1,1s-.45,1-1,1-1-.45-1-1c0-1.65,1.35-3,3-3h4c1.65,0,3,1.35,3,3,0,.55-.45,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSummariesMenu);
export default __webpack_public_path__ + "static/media/user-summaries-menu.c96af5f5615129af6227a2ed4477d7f8.svg";
export { ForwardRef as ReactComponent };